import { ChangeEventHandler, FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

type SendEmailSubjectProps = {
  subject: string;
  onChangeSubject: ChangeEventHandler<HTMLInputElement>;
};

const SendEmailSubject: FC<SendEmailSubjectProps> = ({
  subject,
  onChangeSubject,
}) => {
  const { t } = useTranslate();

  return (
    <div className="nk-reply-form-field">
      <input
        type="text"
        className="form-control form-control-simple"
        placeholder={t('Subject')}
        value={subject}
        onChange={onChangeSubject}
      />
    </div>
  );
};

export default SendEmailSubject;
